import type { Account, Contact } from '@axiom/validation';
import { Api } from '@axiom/ui';

import { EnvUtil } from '../utils/env-util';
import LegacyApiHelper from '../classes/legacy-api-helper';

const api = new LegacyApiHelper('contacts');

export const addAccountsToContact = async ({
  contactId,
  accountIds,
}: {
  contactId: Contact['id'];
  accountIds: Array<Account['id']>;
}) => {
  const { data } = await api.POST(`/contacts/${contactId}/accounts`, {
    accountIds,
  });
  return data;
};

class ContactsLegacyApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  async createContactAccounts({
    contactId,
    accountIds,
  }: {
    contactId: Contact['id'];
    accountIds: Array<Account['id']>;
  }) {
    return super.write<unknown>({
      endpoint: `/contacts/${contactId}/accounts`,
      method: 'POST',
      body: { accountIds },
    });
  }

  async updateContacts(contactId: Contact['id'], body: Partial<Contact>) {
    return super.write<unknown>({
      endpoint: `/contacts/${contactId}`,
      method: 'PATCH',
      body,
    });
  }
}
export const ContactsLegacyApi = new ContactsLegacyApiClass();
